// ── Node rendering constants ──────────────────────────────────────────────────
export const CIRCLE_RADIUS = 10;
export const ICON_DRAW_SIZE = 11;
export const PLUS_RADIUS = 3;
export const PLUS_HIT_RADIUS = 5;
export const MAX_LABEL_WIDTH = 48; // graph-coord units before truncation
export const LABEL_FONT_PX = 3;
export const TYPE_FONT_PX = 2.2;
